// PLAN success acknowledges a batch request; only the batch rollup proves that
// generation completed. Keep legacy responses conservative during rollout.
export function autopilotPlanStatus(state, { unavailable = false, now = Date.now() } = {}) {
  if (unavailable) return 'unknown';
  const run = state?.lastPlanRun;
  if (!run) {
    if (/^(Phase failed|First cycle deferred)/i.test(state?.lastRunSummary || '')) return 'failed';
    if (state?.currentPhase === 'plan') return 'running';
    return state?.lastCycleStartedAt ? 'unknown' : 'idle';
  }
  const batch = run.batch;
  const cycle = currentPlanCycle(state);
  if (run.status === 'failed' || batch?.status === 'failed' || batch?.failedCount > 0 || cycle?.failed > 0) return 'failed';
  if (run.status === 'skipped') return 'skipped';
  if (run.status === 'retrying') return run.errorCode === 'PLAN_ACCEPTANCE_UNCERTAIN' ? 'reconciling' : 'retrying';
  if (run.status === 'running') {
    // A stranded request is not proof of continuing work or a future retry.
    const started = Date.parse(run.startedAt);
    return Number.isFinite(started) && now - started < 15 * 60_000 ? 'running' : 'unknown';
  }
  if (run.status !== 'succeeded') return 'unknown';
  if (batch?.status === 'ready' && batch.totalItems > 0 && batch.readyCount >= batch.totalItems && batch.failedCount === 0) return 'ready';
  if (batch?.status === 'queued') return 'preparing';
  if (batch?.status === 'generating') return 'generating';
  return 'reconciling';
}

// Do not attach a previous successful batch to a newer failed/pending PLAN.
export function currentPlanCycle(state) {
  const run = state?.lastPlanRun;
  return run?.batchId && state?.lastCycle?.batchId === run.batchId ? state.lastCycle : null;
}

export function autopilotActivityStatus(run, now = Date.now()) {
  if (run.status === 'failed') return 'failed';
  if (run.status === 'skipped') return 'skipped';
  if (run.errorCode === 'PLAN_ACCEPTANCE_UNCERTAIN') return 'reconciling';
  if (run.status === 'retrying' || run.errorCode === 'PLAN_ACCEPTANCE_RETRY') return 'retrying';
  if (run.status === 'running') {
    const started = Date.parse(run.startedAt);
    return Number.isFinite(started) && now - started < 15 * 60_000 ? 'running' : 'unknown';
  }
  return run.status === 'succeeded' ? 'accepted' : 'unknown';
}
